import { PeopleHappinessDataItem, PeopleHappinessGroupedData } from '../interfaces/PeopleHappinessDataItem';

export const instanceOfPeopleHappinessGroupedData = (
  object: PeopleHappinessGroupedData | PeopleHappinessDataItem
): object is PeopleHappinessGroupedData => {
  return 'children' in object;
};
